import AdapterJalali from "@date-io/date-fns-jalali";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Box, TextField, Typography } from "@mui/material";
import moment from "jalali-moment";
import React, { useState } from "react";
import { useController } from "react-hook-form";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MuiTheme from "./MuiTheme";
function MuiDatePicker({ value, onChange, disabled = false }) {
  return (
    <LocalizationProvider dateAdapter={AdapterJalali}>
      <MuiTheme>
        {" "}
        <DatePicker
          format="YYYY-MM-DD"
          disabled={disabled}
          mask="____/__/__"
          onChange={onChange}
          value={value}
          inputProps={{ placeholder: "سال/ماه/روز" }}
          renderInput={(params) => (
            <TextField
              size="small"
              sx={{ width: "100%" }}
              {...params}
            />
          )}
          components={{ OpenPickerIcon: CalendarMonthIcon }}
        />
      </MuiTheme>
    </LocalizationProvider>
  );
}
export default MuiDatePicker;
